export enum AccessLogEventType {

  PAGE_VIEW = 'PAGE_VIEW',
  VIDEO_PLAYED_0 = 'VIDEO_PLAYED_0',
  VIDEO_PLAYED_25 = 'VIDEO_PLAYED_25',
  VIDEO_PLAYED_50 = 'VIDEO_PLAYED_50',
  VIDEO_PLAYED_75 = 'VIDEO_PLAYED_75',
  VIDEO_PLAYED_100 = 'VIDEO_PLAYED_100',

}

export default function () {
  const { $api } = useNuxtApp()

  async function addAccessLog(accessLogEventType: AccessLogEventType, eventId: string): Promise<void> {
    await $api('/api/access-log', {
      method: 'POST',
      body: JSON.stringify(accessLogEventType),
      headers: { 'x-event-id': eventId },
    })
  }

  return {
    addAccessLog,
  }
}
